import i18n from "i18n";

export const historicalSchema = [
  {
    id: 1,
    name: i18n.t("trafficMonitoring.historical.schema.directionWest"),
    endpoint: "/rpc/alternative_routes?direction=west",
    xField: "hour_timestamp",
    yField: "avg_tt_paths",
    groupField: "path_name",
    axiosXLabel: i18n.t("trafficMonitoring.historical.schema.timeOfDay"),
    axiosYLabel: i18n.t("trafficMonitoring.historical.schema.travelTime"),
  },
  {
    id: 2,
    name: i18n.t("trafficMonitoring.historical.schema.directionEast"),
    endpoint: "/rpc/alternative_routes?direction=east",
    xField: "hour_timestamp",
    yField: "avg_tt_paths",
    groupField: "path_name",
    axiosXLabel: i18n.t("trafficMonitoring.historical.schema.timeOfDay"),
    axiosYLabel: i18n.t("trafficMonitoring.historical.schema.travelTime"),
  },
  {
    id: 3,
    name: i18n.t("trafficMonitoring.historical.schema.variabilityWest"),
    endpoint: "/rpc/historical_min_max_avg?direction=west&use_last_24h=true",
    xField: "hour_timestamp",
    yField: "value",
    groupField: "path_name",
    splitField: "value_type",
    axiosXLabel: i18n.t("trafficMonitoring.historical.schema.timeOfDay"),
    axiosYLabel: i18n.t("trafficMonitoring.historical.schema.travelTime"),
  },

  {
    id: 4,
    name: i18n.t("trafficMonitoring.historical.schema.variabilityEast"),
    endpoint: "/rpc/historical_min_max_avg?direction=east&use_last_24h=true",
    xField: "hour_timestamp",
    yField: "value",
    groupField: "path_name",
    splitField: "value_type",
    axiosXLabel: i18n.t("trafficMonitoring.historical.schema.timeOfDay"),
    axiosYLabel: i18n.t("trafficMonitoring.historical.schema.travelTime"),
  },
  // {
  //   id: 5,
  //   name: "Maximum Delay West",
  //   endpoint:
  //     "/rpc/historical_diff_max_avg_tt?direction=west&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
  // {
  //   id: 6,
  //   name: "Maximum Delay East",
  //   endpoint:
  //     "/rpc/historical_diff_max_avg_tt?direction=east&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
  // {
  //   id: 7,
  //   name: "Range West",
  //   endpoint: "/rpc/historical_diff_ranges_tt?direction=west&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
  // {
  //   id: 8,
  //   name: "Range East",
  //   endpoint: "/rpc/historical_diff_ranges_tt?direction=east&use_last_24h=true",
  //   xField: "hour_timestamp",
  //   yField: "value",
  //   groupField: "path_name",
  //   splitField: "value_type",
  //   axiosXLabel: "Hours",
  //   axiosYLabel: "Travel Time",
  // },
];
